import {
  MEMBER_BANK_FETCH_REQUEST,
  MEMBER_BANK_FETCH_REQUEST_SUCCESS,
  MEMBER_BANK_FETCH_REQUEST_FAILURE,
  MEMBER_BANK_CLEAN_REQUEST,
  MEMBER_BANK_ADD_REQUEST,
  MEMBER_BANK_ADD_REQUEST_SUCCESS,
  MEMBER_BANK_ADD_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const memberBankReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MEMBER_BANK_FETCH_REQUEST:
    case MEMBER_BANK_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MEMBER_BANK_FETCH_REQUEST_SUCCESS:
    case MEMBER_BANK_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case MEMBER_BANK_FETCH_REQUEST_FAILURE:
    case MEMBER_BANK_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MEMBER_BANK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default memberBankReducer;
